export const TX_TRANSFER_COINS = 'Transfer coins';
export const TX_OWNER_MINT_COINS = 'Mint coins';
export const TX_OWNER_CREATE_COUPON = 'Create coupon';
export const TX_OWNER_DISABLE_ADDRESS = 'Disable address';
export const TX_OWNER_ENABLE_ADDRESS = 'Enable address';
export const TX_REEDEEM_COUPON = 'Redeem coupon';
export const TX_SET_NAME = 'Update name';
export const TX_BUY_COINS = 'Buy coins';
export const TX_GET_ETHER = 'Get Ether';
export const TX_GIVE_ETHER = 'Give Ether';
export const TX_ENABLE_ADDRESS_BUY_COINS = 'Enable address to buy coins';
export const TX_DISABLE_ADDRESS_BUY_COINS = 'Disable address from buying coins';

export const TX_ERROR_TRANSFER_COINS = 'Transaction failed. You are trying to send coins to yourself, or you don\'t have enough coins to send, or your account is frozen.';
export const TX_ERROR_OWNER_MINT_COINS = 'Transaction failed. You are not the owner of the contract.';
export const TX_ERROR_OWNER_CREATE_COUPON = 'Transaction failed. Coupon already exists.';
export const TX_ERROR_OWNER_DISABLE_ADDRESS = 'Transaction failed. You are not the owner of the contract or you are trying to freeze your own address.';
export const TX_ERROR_OWNER_ENABLE_ADDRESS = 'Transaction failed. You are not the owner of the contract, or the address is not frozen.';
export const TX_ERROR_REDEEM_COUPON = 'Transaction failed. Coupon doesn\'t exist or is already redeemed.';
export const TX_ERROR_BUY_COINS = 'Transaction failed. You need to spend at least 1 ether to buy coins.';
export const TX_ERROR_GET_ETHER = 'Transaction failed.';
export const TX_ERROR_GIVE_ETHER = 'Transaction failed.';


// WEBPACK FOOTER //
// ./src/utils/TransactionTypes.js